<div
  class="session-card"
  [ngClass]="{
    restricted: session.config.restricted,
    deactivated: session.config.deactivated,
  }">
  <ng-container
    *ngIf="!newIdea || permissions.session.data.ideas.post(session)">
    <div class="session-card-wrapper">
      <div class="session-card-header">
        <div class="session-information">
          <a
            routerLink="/topics/{{ session._id }}"
            [queryParams]="newIdea ? { newIdea: true } : {}">
            <h3>{{ session.config.title }}</h3>
            <p>{{ session.config.one_liner }}</p>
          </a>
        </div>
        <a
          routerLink="/topics/{{ session._id }}"
          [queryParams]="newIdea ? { newIdea: true } : {}">
          <img
            alt
            [src]="
              session.config.thumbnail_id ||
                'image/default_session_thumbnail.png' | assets
            " />
        </a>
      </div>
      <div class="session-card-footer">
        <img
          alt
          *ngIf="session.config.organizer && session.config.organizer.enabled"
          class="organiser-logo"
          [src]="session.config.organizer.logo_id | assets" />
        <p class="followers">
          <span
            (click)="session.i_follow ? unfollow() : follow()"
            [ngClass]="
              session.i_follow ? 'icon-star-full' : 'icon-star-empty'
            "></span>
          ({{ session.data.followers }})
        </p>
        <a
          class="enter-session"
          routerLink="/topics/{{ session._id }}"
          [queryParams]="newIdea ? { newIdea: true } : {}">
          {{ newIdea ? 'Select' : 'Enter' }}
          {{ session.config.cluster ? 'Topic Cluster' : 'Topic' }}
          <i class="fa fa-angle-right" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </ng-container>
  <div
    class="deactivation-notice"
    *ngIf="session.config.deactivated"
    tooltip="{{ session.config.deactivation_message }}"
    placement="bottom">
    Topic is Not Active
    <i class="icon-info"></i>
  </div>
</div>
